import React from 'react';
import PropTypes from 'prop-types';

const Question = ({ name, hidden, show, children }) => (
  <div className="grid-question">
    {!hidden && show ? (
      <>
        <div className="column-question-first">{name}</div>
        <div className="column-question">{children}</div>
      </>
    ) : (
      ''
    )}
  </div>
);

Question.propTypes = {
  name: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  hidden: PropTypes.bool,
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};
Question.defaultProps = {
  hidden: false,
};

export default Question;
